/**
 * A function for building namespaced action names.
 *
 * @param {string} storeName - The name of the store or module to namespace actions under.
 *
 * @returns {function(string): string} A function that takes an action name and returns
 *                                  a namespaced action string in the format "storeName/actionName".
 */
export function actionNameBuilder(storeName: string) {
  /**
   * Generates a namespaced action name.
   *
   * @param {string} actionName - The name of the action to be namespaced.
   * @returns {string} The namespaced action in the format "storeName/actionName".
   */
  return function actionName(actionName: string) {
    return `${storeName}/${actionName}`;
  };
}
